// extracted by mini-css-extract-plugin
module.exports = {"venue__location":"ob_hdb0gs","venue__name":"ob_fCwun4","country":"ob_1W5zaa","moreVenues":"ob_Skjgzt"};